import Container from "@mui/material/Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { StyledCategoryImage } from "@Styled/Layout/header";
import React, { memo, useContext, useEffect } from "react";
import { ICategory } from "@Interfaces/Api/category";
import Link from "next/link";
import Image from "next/image";
import { AllRootCategoryContext } from "@Pages/index";
import { CategoryImageMobileSkeleton } from "@Components/Loader/Skeleton";
import { theme } from "@Definitions/Styled";

interface mobileCategoryHeaderProps { }

const MobileCategoryHeader = ({ }: mobileCategoryHeaderProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = React.useState(true);

  const allRootCategories = useContext<ICategory[]>(AllRootCategoryContext);

  useEffect(() => {
    if (allRootCategories.length > 0) {
      setIsLoading(false);
    }
  }, [allRootCategories.length]);

  if (isLoading && isMobile) {
    return CategoryImageMobileSkeleton;
  }
  return (
    <div>
      <Container sx={{ display: "flex", overflowX: "auto" }}>
        {allRootCategories.map((category) => (
          <Box
            sx={{
              marginRight: { xs: "1rem", sm: "2.5rem" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            key={category._id}
          >
            <Link href={`/collections/${category.slug}`}>
              <StyledCategoryImage
                sx={{
                  display: { xs: "flex", sm: "none" },
                }}
              >
                <Image
                  alt={category.name}
                  src={category.image!.url}
                  style={{
                    borderRadius: "32.5px",
                  }}
                  fill={true}
                  // width={60}
                  // height={60}
                  priority={true}
                />
              </StyledCategoryImage>
            </Link>
            <Link href={`/collections/${category.slug}`}>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "0.75rem",
                  marginBottom: "0.7rem",
                  textAlign: "center",
                  textTransform: { xs: "capitalize", sm: "uppercase" },
                  display: { xs: "flex", sm: "none" },
                }}
              >
                {category.name}
              </Typography>
            </Link>
          </Box>
        ))}
      </Container>
    </div>
  );
};

export default memo(MobileCategoryHeader);
